var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React from 'react';
import styles from './Button.module.scss';
export var Theme;
(function (Theme) {
    Theme["PRIMARY_THEME"] = "primary";
    Theme["PRIMARY_INVERSE_THEME"] = "primary-inverse";
    Theme["SECONDARY_THEME"] = "secondary";
    Theme["SECONDARY_INVERSE_THEME"] = "secondary-inverse";
    Theme["TERTIARY_THEME"] = "tertiary";
    Theme["MONOCHROME_THEME"] = "monochrome";
    Theme["OVERLAY_THEME"] = "overlay";
})(Theme || (Theme = {}));
export var Size;
(function (Size) {
    Size["SMALL_SIZE"] = "small";
    Size["MEDIUM_SIZE"] = "medium";
    Size["LARGE_SIZE"] = "large";
})(Size || (Size = {}));
/**
 * Primary UI component for user interaction
 */
const Button = (_a) => {
    var { theme = Theme.SECONDARY_THEME, scale = Size.MEDIUM_SIZE, block, icon, iconLast, iconOnly, iconSize = Size.SMALL_SIZE, loading, children, className, useAnchor } = _a, props = __rest(_a, ["theme", "scale", "block", "icon", "iconLast", "iconOnly", "iconSize", "loading", "children", "className", "useAnchor"]);
    const buttonStyles = classnames(styles.button, className, {
        [styles.buttonPrimary]: theme === Theme.PRIMARY_THEME,
        [styles.buttonPrimaryInverse]: theme === Theme.PRIMARY_INVERSE_THEME,
        [styles.buttonSecondary]: theme === Theme.SECONDARY_THEME,
        [styles.buttonSecondaryInverse]: theme === Theme.SECONDARY_INVERSE_THEME,
        [styles.buttonTertiary]: theme === Theme.TERTIARY_THEME,
        [styles.buttonMonochrome]: theme === Theme.MONOCHROME_THEME,
        [styles.buttonOverlay]: theme === Theme.OVERLAY_THEME,
        [styles.buttonSmall]: scale === Size.SMALL_SIZE,
        [styles.buttonMedium]: scale === Size.MEDIUM_SIZE,
        [styles.buttonLarge]: scale === Size.LARGE_SIZE,
        [styles.buttonBlock]: block,
        [styles.buttonIconLast]: iconLast,
        [styles.buttonLoading]: loading,
        [styles.buttonIconOnly]: iconOnly,
    });
    const iconStyles = classnames(styles.buttonIcon, {
        [styles.buttonIconLarge]: iconSize === Size.LARGE_SIZE,
        [styles.buttonIconMedium]: iconSize === Size.MEDIUM_SIZE,
        [styles.buttonIconSmall]: iconSize === Size.SMALL_SIZE,
    });
    const buttonTextStyles = classnames(styles.buttonText, {
        srOnly: iconOnly,
    });
    const buttonChildren = (<>
      {icon ? (<span className={iconStyles} aria-hidden='true' style={{
                WebkitMaskImage: `url(${icon})`,
                maskImage: `url(${icon})`,
            }}/>) : null}
      {loading ? <span className={styles.buttonLoader}>Loading</span> : null}
      <span className={buttonTextStyles} aria-hidden={loading}>
        {children}
      </span>
    </>);
    const elementType = props.href || useAnchor ? 'a' : 'button';
    let buttonType = {};
    if (elementType === 'button' && props.onClick) {
        buttonType = { type: props.type || 'button' };
    }
    const finalProps = Object.assign(Object.assign({}, props), buttonType);
    return (<>
      {React.createElement(elementType, Object.assign(Object.assign({ disabled: loading }, finalProps), { className: buttonStyles }), buttonChildren)}
    </>);
};
export default Button;
